import React, { useEffect, useRef, useState } from "react";
import "./Header.css";
import ClubLogo from "../../assets/secion_badge-Photoroom.png";

const primaryLinks = [
  { label: "Home", page: "home" },
  { label: "Jampot Rally", page: "jampot" },
  { label: "Bikes", page: "bikes" },
  { label: "Technical", page: "wiki" },
  { label: "Parts", page: "parts" },
  { label: "Trusted Suppliers", page: "suppliers" },
  { label: "Contact", href: "mailto:southwest@jampot.com" },
];

function Header({ selectedPage, onNavigate, secondaryMenuItems }) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleNavigation = (page) => {
    onNavigate(page);
    setIsMenuOpen(false);
  };

  const handleLinkClick = () => {
    setIsMenuOpen(false);
  };

  return (
    <>
      <header className="site-header">
        <button
          type="button"
          className="site-header__brand"
          onClick={() => handleNavigation("home")}
          aria-label="Go to home page"
        >
          <img src={ClubLogo} alt="AJS and Matchless Owners Club crest" className="site-header__logo" />
          <span className="site-header__brand-copy">
            <span className="site-header__brand-title">AJS &amp; Matchless Owners Club</span>
            <span className="site-header__brand-subtitle">Devon &amp; Cornwall Section</span>
          </span>
        </button>

        <button
          type="button"
          className="site-header__toggle"
          onClick={() => setIsMenuOpen((open) => !open)}
          aria-expanded={isMenuOpen}
          aria-label="Toggle navigation"
        >
          <span />
          <span />
          <span />
        </button>

        <nav
          ref={menuRef}
          className={`site-header__nav${isMenuOpen ? " site-header__nav--open" : ""}`}
        >
          {primaryLinks.map((item) => (
            item.href ? (
              <a key={item.label} href={item.href} onClick={handleLinkClick}>
                {item.label}
              </a>
            ) : (
              <button
                key={item.label}
                type="button"
                className={selectedPage === item.page ? "active" : ""}
                onClick={() => handleNavigation(item.page)}
              >
                {item.label}
              </button>
            )
          ))}
        </nav>
      </header>

      {secondaryMenuItems && secondaryMenuItems.length > 0 && (
        <nav className="secondary-nav">
          {secondaryMenuItems.map((item) => (
            <button
              key={item.name}
              className={item.isActive ? "active" : ""}
              onClick={item.onClick}
            >
              {item.name}
            </button>
          ))}
        </nav>
      )}
    </>
  );
}

export default Header;
